import React from "react";
import { Modal } from "react-bootstrap";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
import InputName from "../../common/Input/InputName";

const AddUpdatePhlebotomist = ({
  showModal,
  setModalVisible,
  formData,
  handleChange,
  handleCreatePhlebotomist,
  setInputError,
  modalAction,
}) => {
  return (
    <Modal centered show={showModal} onHide={() => setModalVisible(false)}>
      <div className="modal-header">
        <h5>
  {modalAction === "create"
    ? "Add Phlebotomist"
    : "Update Phlebotomist"}
</h5>
      </div>

      <form onSubmit={handleCreatePhlebotomist}>
        <div className="modal-body">
          <div className="col-xl-6">
            <div className="form-group">
              <InputName
                name="name"
                value={formData?.name}
                onChange={handleChange}
                placeholder=" Enter Your Name"
                label="Name"
                setInputNameError={setInputError}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="form-group">
              <InputEmail
                name="email"
                value={formData?.email}
                onChange={handleChange}
                label="Email"
                placeholder="Enter Email"
                setInputEmailError={setInputError}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="form-group">
              <InputNumber
                name="mobileNo"
                value={formData?.mobileNo}
                onChange={handleChange}
                label="Mobile"
                placeholder="Enter Mobile Number"
                setInputNumberError={setInputError}
              />
            </div>
          </div>

          <div className="col-xl-6">
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setModalVisible(false)}
          >
            Close
          </button>

          <button
  type="submit"
  className="btn btn-primary"
>
  {modalAction === "create"
    ? "Create"
    : "Update"}
</button>
        </div>
      </form>
    </Modal>
  );
};

export default AddUpdatePhlebotomist;
